<template>

  <!-- Vendor Presentations Content -->
  <div
    class="vendor-presentations-content">

    <div
      class="d-grid grid-gap-2">

      <presentation-card
        :key="index"
        :value="item"
        @click="show(item)"
        v-for="(item, index) in items"/>

    </div>

  </div>

</template>

<script>

  import {mapState, mapActions} from 'vuex';
  import PresentationCard from '@src/components/card/presentation-card';

  export default {
    name: 'vendor-presentations-content',
    components: {
      PresentationCard,
    },
    props: {
      items: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      ...mapState('vlVendors', {
        vendor: 'item',
      }),
    },
    methods: {
      ...mapActions('session', {
        addScore: 'ADD_SCORE',
      }),
      ...mapActions('vlVendors', {
        addViewOf: 'ADD_VIEW_OF',
      }),
      show(item) {

        // Add Score.

        // this.addScore({
        //   referenceId: item.id,
        //   referenceType: 'material',
        //   vendorId: this.vendor.id,
        //   name: 'view-vendor-presentation',
        // });

        // Add View.

        // this.addViewOf({
        //   id: item.id,
        //   field: 'presentations',
        // });

        // Show.

        const link = item.useLink
          ? item.link
          : this.getFileUrl(item.file);

        window.open(
          link,
          '_blank',
        );
      },
    },
  };

</script>

<style lang="scss">

  .vendor-presentations-content {
    color: inherit;
  }

</style>
